import json from './sprite.js';

export default {
    handle: 'en_SPT9-Broken-Window-Boy',
    label: 'en_SPT9-Broken-Window-Boy',
    json,
};
